import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { setError, isLoading } from 'containers/Checkout/actions'

import { API_ADDRESS_UPDATE_URL } from 'containers/Checkout/constants'
import { GA_EVENT_CATEGORY } from './constants'

export const MULTI_ADDRESS_SHOW_MORE_ADDRESSES = 'MULTI_ADDRESS_SHOW_MORE_ADDRESSES'
export const MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE = 'MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE'
export const MULTI_ADDRESS_UPDATE_SUCCESS = 'MULTI_ADDRESS_UPDATE_SUCCESS'
export const MULTI_ADDRESS_LOADED = 'MULTI_ADDRESS_LOADED'

export function updateAddressSuccess(address, nextStage) {
  return {
    type: MULTI_ADDRESS_UPDATE_SUCCESS,
    payload: { address, nextStage },
  }
}

export function displayMoreAddresses() {
  return { type: MULTI_ADDRESS_SHOW_MORE_ADDRESSES }
}

export function selectSingleAddress(address) {
  return {
    type: MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE,
    payload: address,
  }
}

export function loadedAddresses(addresses) {
  return {
    type: MULTI_ADDRESS_LOADED,
    payload: addresses,
  }
}

export function updateAddress(newAddressId) {
  return (dispatch) => {
    dispatch(isLoading(true))
    axios
      .put(API_ADDRESS_UPDATE_URL, { id: newAddressId })
      .then((response) => {
        if (response.data.success) {
          dispatch(updateAddressSuccess(response.data.address, response.data.next))
          gaEvent('Success', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Address Updated',
          })
        } else {
          dispatch(setError(true))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Network Error',
          })
        }
      })
      .catch(() => {
        dispatch(setError(true))
        gaEvent('Error', {
          event_category: GA_EVENT_CATEGORY,
          event_label: 'Network Error',
        })
      })
  }
}

export function loadAddresses() {
  return (dispatch) => {
    dispatch(isLoading(true))
    axios
      .get(API_ADDRESS_UPDATE_URL)
      .then((response) => {
        dispatch(loadedAddresses(response.data.addresses))
        gaEvent('Success', {
          event_category: GA_EVENT_CATEGORY,
          event_label: 'Addresses Loaded',
          non_interaction: true,
        })
      })
      .catch(() => {
        dispatch(setError(true))
        gaEvent('Error', {
          event_category: GA_EVENT_CATEGORY,
          event_label: 'Network Error',
          non_interaction: true,
        })
      })
  }
}



// WEBPACK FOOTER //
// ./containers/stages/MultipleAddressStage/actions.js